import { createSlice } from '@reduxjs/toolkit';
import { NutritionState } from './NutritionTypes';
import {
  requestNutritionPlanOperation,
  getLatestNutritionPlanOperation,
  getNutritionPlanStatusOperation,
  fetchRecipeOperation,
} from './nutrition-operations';

const initialState: NutritionState = {
  plan: null, // Используем мок данные вместо null
  loadingPlan: false,

  recipe: null,
  loadingRecipe: false,

  error: null,
};

const nutritionSlice = createSlice({
  name: 'nutrition',
  initialState,
  reducers: {
    resetNutritionState: () => initialState,
  },
  extraReducers: builder => {
    /* ─────── nutrition-plan ─────── */
    builder.addCase(requestNutritionPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(requestNutritionPlanOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(requestNutritionPlanOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    builder.addCase(getLatestNutritionPlanOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getLatestNutritionPlanOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getLatestNutritionPlanOperation.rejected, (s, { payload, error }) => {
      if (payload?.status === 409) {
        s.loadingPlan = true;
        s.error = null;
        return;
      }
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    builder.addCase(getNutritionPlanStatusOperation.pending, s => {
      s.loadingPlan = true;
      s.error = null;
    });
    builder.addCase(getNutritionPlanStatusOperation.fulfilled, (s, { payload }) => {
      s.plan = payload;
      s.loadingPlan = false;
    });
    builder.addCase(getNutritionPlanStatusOperation.rejected, (s, { payload, error }) => {
      s.loadingPlan = false;
      s.error = payload?.message || error.message || null;
    });

    /* ─────── recipes ─────── */
    builder.addCase(fetchRecipeOperation.pending, s => {
      s.loadingRecipe = true;
      s.error = null;
    });
    builder.addCase(fetchRecipeOperation.fulfilled, (s, { payload }) => {
      s.recipe = payload;
      s.loadingRecipe = false;
    });
    builder.addCase(fetchRecipeOperation.rejected, (s, { payload, error }) => {
      s.loadingRecipe = false;
      s.error = payload?.message || error.message || null;
    });
  },
});

export const { resetNutritionState } = nutritionSlice.actions;
export default nutritionSlice.reducer;
